function SaveGame(props) {
  return (
    <div>
      <h1>Save Game</h1>
      <button>Save</button>
    </div>
  );
}

export default SaveGame;
